// Engagement components (E - Enhanced Discoverability)
export { RoleBasedCTA } from "./role-based-cta";
export type { RoleBasedCTAProps } from "./role-based-cta";

// P2 Advanced Features
export { FAQSchema } from "./faq-schema";
export type { FAQSchemaProps, FAQItem } from "./faq-schema";

export { NewsletterSignup } from "./newsletter-signup";
export type { NewsletterSignupProps, NewsletterVariant } from "./newsletter-signup";

export { DownloadableAsset } from "./downloadable-asset";
export type { DownloadableAssetProps } from "./downloadable-asset";
